import React from 'react';
import ReactDOM from 'react-dom';
import { renderToString, renderToStaticMarkup } from 'react-dom/server';
import { StaticRouter, BrowserRouter } from 'react-router-dom';
import { matchRoutes, renderRoutes } from 'react-router-config';
import { Provider } from 'react-redux';
import Template from '../src/Template';
import routes from '../src/routes';
import configureStore from '../src/store/configureStore';

/*
	Entry point for client-side application.
	Send Url's through application's router and return html to static site gen plugin
*/

const isClient = typeof document !== 'undefined';

if (isClient) {
	const store = configureStore(window.INITIAL_STATE); // Initial state is taken from Template generated server side.

	// Should use hydrate instead
	ReactDOM.render(
		<Provider store={store}>
			<BrowserRouter>
				{renderRoutes(routes)}
			</BrowserRouter>
		</Provider>,
		document.getElementById('content'),
	);
}

// enable service workers on client
if (typeof process !== 'undefined' && process.env.ADD_SW && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(`${__webpack_public_path__}sw.js`);
}

const renderComponentWithRoot = (location, store) => {
	const context = {};

	const componentHtml = renderToString(
		<Provider store={store}>
			<StaticRouter location={location} context={context}>
				{renderRoutes(routes)}
			</StaticRouter>
		</Provider>,
	);

	const initialState = store.getState();
	// Add React helmet here
	// const head = Helmet.rewind();

	// Need to know script filenames here.
	const templateMarkup = renderToStaticMarkup(
		<Template content={componentHtml} initialState={initialState} /* head={head} */ />,
	);

	return `<!doctype html>\n${templateMarkup}`;
};

const staticRoutes = (locals, callback) => {
	const branch = matchRoutes(routes, locals.path);
	const store = configureStore();

	// Optimization to be made. Every route will get similar data.
	const promises = branch.map(({ route }) => {
		const fetchData = route.component.fetchData;
		return fetchData instanceof Function ? fetchData(store) : Promise.resolve(null);
	});

	return Promise.all(promises).then(() => callback(null, renderComponentWithRoot(locals.path, store)));
};

export default staticRoutes;



// WEBPACK FOOTER //
// ../build/entry.jsx